import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import IntlTelInput from "react-intl-tel-input";
import Recaptcha from "../../modules/Recaptcha/Recaptchav2";

const SignUp = ({ dispatch_danger, dispatch_post_register }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  const { rc } = useParams();
  const [recaptcha, set_recaptcha] = useState("");
  let ReferralCode = "";

  useEffect(() => {
    if (sessionStorage.getItem("ReferralCode")) {
      ReferralCode = sessionStorage.getItem("ReferralCode");
    } else {
      if (rc) {
        ReferralCode = rc;
        sessionStorage.setItem("ReferralCode", ReferralCode);
      } else {
        ReferralCode = "";
      }
    }
    set_referral_code(ReferralCode);
  }, []);

  const [display_name, set_display_name] = useState("");
  const [mail_address, set_mail_address] = useState("");
  // const [phone_number, set_phone_number] = useState("");
  // const [country_code, set_country_code] = useState("JP");
  const [password, set_password] = useState("");
  const [password_confirm, set_password_confirm] = useState("");
  const [check, set_check] = useState(false);

  const [country_code, set_country_code] = useState("");
  const [phone_number, set_phone_number] = useState("");
  const [phone_number_international, set_phone_number_international] = useState(
    ""
  );
  const [referral_code, set_referral_code] = useState(ReferralCode);

  return (
    <>
      <div class="bg-light">
        <form
          action="verify.html"
          method="post"
          className="d-flex flex-column justify-content-between vh-200"
        >
          <header className="py-3 mb-auto bg-brand">
            <div className="container d-flex justify-content-between align-items-center">
              <a
                className="text-white"
                href="javascript:history.back();"
                onClick={(e) => {
                  e.preventDefault();
                  history.goBack();
                  window.scroll(0, 0);
                }}
              >
                <i className="fas fa-angle-left fa-fw" />
                {t("戻る")}
              </a>
              <a
                href="index.html"
                onClick={(e) => {
                  e.preventDefault();
                  history.push({
                    pathname: `/top`,
                  });
                  window.scroll(0, 0);
                }}
              >
                <img src="/images/brand-white.svg" height={28} alt="SC WORLD EXCHANGE" />
              </a>
            </div>
          </header>
          <main role="main" className="main footer-fixed my-auto">
            <div className="container">
              <section className="create-section mx-auto">
                <div className="row">
                  <div className="col-lg-5 text-center d-flex flex-column justify-content-center">
                    <div className="row d-none d-lg-block">
                      <div className="col-lg-4 mx-auto pb-4">
                        <img className="img-fluid" src="/images/brand.svg" />
                      </div>
                    </div>
                    <h1 className="h5 mb-4 mb-lg-0">
                      {t("SC WORLD EXCHANGE アカウント作成")}
                    </h1>
                  </div>
                  <div className="col-lg-7">
                    <h2 className="lead d-none d-sm-block">
                      {t("アカウント情報")}
                    </h2>
                    <div className="form-group">
                      <label htmlFor="nm">{t("表示名")}</label>
                      <input
                        type="text"
                        id="nm"
                        className="form-control"
                        placeholder={t("表示名を入力してください")}
                        required
                        // autofocus
                        value={display_name}
                        onChange={(e) => {
                          set_display_name(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="ml">{t("メールアドレス")}</label>
                      <input
                        type="email"
                        id="ml"
                        className="form-control"
                        placeholder={t("メールアドレス")}
                        required
                        value={mail_address}
                        onChange={(e) => {
                          set_mail_address(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="pn">{t("電話番号")}</label>
                      <div className="input-group">
                        <IntlTelInput
                          containerClassName="intl-tel-input"
                          inputClassName="form-control"
                          preferredCountries={["jp", "us"]}
                          defaultCountry={country_code}
                          placeholder=""
                          value={phone_number}
                          onSelectFlag={(
                            value,
                            obj,
                            formattedvalue,
                            isValid
                          ) => {
                            set_country_code(obj.iso2);
                            // areaCodes:null
                            // dialCode:'93'
                            // iso2:'af'
                            // name:'Afghanistan (‫افغانستان‬‎)'
                            // priority:0

                            set_phone_number(value);
                            !isValid ||
                              set_phone_number_international(
                                formattedvalue
                                  .replace(/-/g, "")
                                  .replace(/ /g, "")
                              );
                            // !isValid || set_phone_number_international(formattedvalue);
                            isValid || set_phone_number_international("");
                          }}
                          onPhoneNumberChange={(
                            isValid,
                            value,
                            obj,
                            formattedvalue
                          ) => {
                            set_country_code(obj.iso2);
                            set_phone_number(value);
                            !isValid ||
                              set_phone_number_international(
                                formattedvalue
                                  .replace(/-/g, "")
                                  .replace(/ /g, "")
                              );
                            // !isValid || set_phone_number_international(formattedvalue);
                            isValid || set_phone_number_international("");
                          }}
                          // onPhoneNumberBlur={onBlur}
                          format
                        />

                        {/* 
                        <div className="input-group-prepend">
                          <select className="form-control">
                            <option>+91</option>
                          </select>
                        </div>
                        <input
                          type="tel"
                          id="pn"
                          className="form-control"
                          placeholder="00000000000"
                          required
                          value={phone_number}
                          onChange={(e) => {
                            set_phone_number(e.target.value);
                          }}
                        /> */}
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="pwi">{t("パスワード")}</label>
                      <div className="form-row">
                        <div className="col-md">
                          <input
                            type="password"
                            id="pwi"
                            className="form-control"
                            placeholder={t("パスワード")}
                            required
                            value={password}
                            onChange={(e) => {
                              set_password(e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-md">
                          <input
                            type="password"
                            id="pwc"
                            className="form-control"
                            placeholder={t("パスワード(確認用)")}
                            required
                            value={password_confirm}
                            onChange={(e) => {
                              set_password_confirm(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <small className="form-text">
                        {t(
                          "大文字小文字数字混在の１０文字以上で入力してください。"
                        )}
                      </small>
                    </div>
                    <div className="form-group">
                      <label htmlFor="cd">{t("紹介コード")}</label>
                      <div className="form-row">
                        <input
                          type="tel"
                          id="cd"
                          className="form-control"
                          // placeholder={1234}
                          value={referral_code}
                          onChange={(e) => {
                            set_referral_code(e.target.value);
                          }}
                          // readOnly={true}
                        />
                      </div>
                    </div>
                    <div className="form-group form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="agree"
                        value={check}
                        onChange={(e) => {
                          set_check(e.target.checked);
                        }}
                      />
                      <label className="form-check-label" htmlFor="agree">
                        {t("下記重要事項に同意する")}
                      </label>
                    </div>
                    <div className="form-group text-left">
                      {/* {t("Google reCAPTCHA")} */}
                      <Recaptcha set_recaptcha={set_recaptcha} action="login" />
                    </div>
                  </div>
                </div>
                <p className="mt-2 mb-5">
                  <span className="text-muted">
                    {t("ログインすると、")}
                    <a
                      href="docs/tos.html"
                      onClick={(e) => {
                        e.preventDefault();
                        history.push({
                          pathname: `/tos`,
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      {t("利用規約")}
                    </a>{" "}
                    {t("と")}
                    <a
                      href="docs/privacy.html"
                      onClick={(e) => {
                        e.preventDefault();
                        history.push({
                          pathname: `/privacy`,
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      {t("プライバシーポリシー")}
                    </a>
                    {t("に同意したことになります。")}
                  </span>
                </p>
              </section>
            </div>
          </main>
          <div className="container mt-auto mb-4 fixed-bottom">
            <div className="row pb-2">
              <div className="col-10 col-lg-4 mx-auto">
                <button
                  // type="submit"
                  type="button"
                  className="btn btn-gradient-primary btn-lg btn-block"
                  onClick={() => {
                    if (password !== password_confirm) {
                      dispatch_danger(t("パスワードが異なっています。"));
                      return;
                    }

                    if (!check) {
                      dispatch_danger(t("重要事項に同意していません。"));
                      return;
                    }
                    dispatch_post_register(
                      {
                        recaptcha: recaptcha,
                        display_name,
                        mail_address,
                        phone_number: phone_number_international,
                        password,
                        country_code,
                        referral_code,
                      },
                      () => {
                        history.push({
                          pathname: `/signupcode`,
                        });
                        window.scroll(0, 0);
                      }
                    );
                  }}
                >
                  {t("新規登録")}
                  <i className="fas fa-arrow-alt-circle-right fa-fw" />
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default SignUp;
